export const INTRO_HTML =
  "<b>ACIM Workbook Lessons on the AEG Dashboard</b><br/><br/> Through the <b>Anahat Education Group (AEG) Dashboard</b>, you can engage with the <b>Daily Workbook Lessons</b> from <b>A Course in Miracles (ACIM).<br/> Key Features:</b>";

export const MIDDLE_HTML =
  "These lessons offer a structured, practical approach to applying the teachings of <b>A Course in Miracles</b> in your daily life. Start your journey to inner peace and transformation today! <br/><br/><b>Structure of the Course</b>";

export const STUDY_GROUP_TITLE = "A Course in Miracles Study Group with";
export const STUDY_GROUP_AUTHOR = "Matthew J Brownstein";

export const LINK_BOX_TITLE =
  "Click Here to Join Class Every Sunday at 7:00pm EST";
export const LINK_BOX_URL = "https://us06web.zoom.us/j/84303643224";

export const ACIM_STUDY_LINK = "https://www.instituteofhypnotherapy.com/acim/";

export const TAB_LESSONS = "lessons";

export const miraclesData = [
  // {
  //   id: 1,
  //   title: "365 Lessons in Total",
  //   text: "Each lesson is designed to be practiced daily, guiding you step by step through a process of inner transformation.",
  //   link: "https://acim.org/acim/en",
  // },
  // {
  //   id: 2,
  //   title: "Workbook Introduction",
  //   text: "Before starting, read the Workbook Introduction to understand the purpose and methodology of the lessons.",
  //   link: "https://acim.org/acim/en",
  // },
  {
    id: 3,
    title: "Integrated Dashboard Access",
    text: "Simply click the button below to begin receiving ACIM Workbook Lessons directly on your AEG Dashboard.",
    type: "clickable",
    size: 12,
  },
  // {
  //   id: 4,
  //   title: "Text",
  //   text: "The theoretical foundation of the course, explaining its metaphysical and spiritual concepts.",
  //   text2:
  //     "It focuses on the nature of reality, the illusion of the physical world, and the role of forgiveness in spiritual awakening.",
  //   bigH: true,
  //   size: 6,
  //   link: "https://acim.org/acim/text/introduction/en/s/51?wid=toc&fwv=true",
  // },
  // {
  //   id: 5,
  //   title: "Workbook for Students",
  //   text: "A practical guide consisting of <b>365 daily lessons.</b>",
  //   text2:
  //     "Each lesson is designed to train the mind to think in alignment with the principles of love and forgiveness, replacing fear-based thought patterns.",
  //   bigH: true,
  //   size: 6,
  //   link: "https://acim.org/acim/workbook/introduction/en/s/401?wid=toc&fwv=true",
  // },
  {
    id: 6,
    title: "ACIM Web Version",
    text: "A supplementary section providing guidance for those who feel called to teach or share the course's principles.",
    text2: "It answers common questions and offers clarity on key ideas.",
    size: 12,
    height: "150px",
    link: "https://acim.org/acim/en",
  },
];
